import React from 'react';
import './radio.css';
import clsx from 'clsx';

export enum RadioSize {
  base = 'base',
  lg = 'lg',
}

export interface RadioProps {
  checked: boolean;
  collectionColor?: boolean;
  isCrossed?: boolean;
  color: string;
  name?: string;
  register?: any;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  size: string;
}

const returnRadioSize = (size: string): string => {
  switch (size) {
    case 'xs':
      return 'w-5 h-5';
    case 'sm':
      return 'w-6 h-6';
    case 'base':
      return 'w-8 h-8';
    case 'lg':
      return 'w-10 h-10';
    default:
      return '';
  }
};

const returnRadioRingSize = (size: string): string => {
  switch (size) {
    case 'xs':
      return 'w-3 h-3';
    case 'sm':
      return 'w-4 h-4';
    case 'base':
      return 'w-6 h-6';
    case 'lg':
      return 'w-5 h-5';
    default:
      return '';
  }
};

export const Radio = ({
  collectionColor,
  color,
  checked,
  name,
  size,
  isCrossed,
  register,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: RadioProps) => {
  const hover =
    'hover:ring-4 hover:ring-offset-2 hover:ring-gray-500 hover:ring-opacity-25';
  const active = 'active:ring-opacity-50';
  // const focus = "ring-opacity-100 ring-2 ring-offset-2 ring-gray-500";
  const isFreeBackground = collectionColor ? '' : color;
  const isCheckedStyle = checked && `bg-white ${returnRadioRingSize(size)}`;
  const isCollectionColorChecked =
    collectionColor && checked ? `bg-${color}` : '';
  const isCollectionColorNotChecked =
    collectionColor && !checked ? 'ring-1 ring-black' : '';
  const isColorCrossed = isCrossed ? 'opacity-90' : '';

  return (
    <span
      style={{
        background: isFreeBackground,
      }}
      className={clsx(
        'relative transition duration-300 ease-in-out rounded-full cursor-pointer flex items-center justify-center',
        returnRadioSize(size),
        hover,
        active,
        isCollectionColorChecked,
        isCollectionColorNotChecked,
        isColorCrossed
      )}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-hidden='true'>
      {isCrossed && <span className='absolute radio-crossed w-5 h-5' />}
      <span
        value={color}
        {...(register && register(name))}
        className={clsx(
          'rounded-full transition duration-300 ease-in-out',
          isCheckedStyle
        )}
      />
    </span>
  );
};
